import { Screen, screens } from "../../app/core/screen";
import { getAvailableId } from "../components/components/component";
import { ll } from "../core/ll";
import { emptyFn } from "../core/util";
import { SimpleScreen } from "./simpleScreen";

function fixKendoWindowDrag(container) {
    $.wait(1).then(function () {
        var parent = container.parent()[0];
        var nodes = parent.childNodes as any[];
        $.each(nodes, function (index, node) {
            if (index > 1) {
                parent.removeChild(node);
            }
        });
    });
    $.wait(10).then(function () {
        var parent = container.parent()[0];
        var nodes = parent.childNodes as any[];
        $.each(nodes, function (index, node) {
            if (index > 1) {
                parent.removeChild(node);
            }
        });
    });
    $.wait(100).then(function () {
        var parent = container.parent()[0];
        var nodes = parent.childNodes as any[];
        $.each(nodes, function (index, node) {
            if (index > 1) {
                parent.removeChild(node);
            }
        });
    });
}

var nextPopUpZIndex = 20000;

var PopUp = function (options) {
    options = options || {};

    if (!options.name) {
        options.name = options.id;
    }
    var overlayZIndex = options.zIndex ? options.zIndex++ : nextPopUpZIndex++;
    var popupZIndex = options.zIndex ? options.zIndex++ : nextPopUpZIndex++;
    options.popUpScreen = true;

    // Create screen object that we will inherit from
    var screen = new (Screen as any || SimpleScreen)(options);
    // Inherit screen into order object
    $.extend(this, screen);
    var screenName = options.name;
    delete options.name; // removing since kendo thinks they are smart

    var id = `${this.id}_${(options.id || "dialog")}`,
        buttons = options.buttons || [{ name: "OK" }],
        close = options.close || emptyFn,
        dialogEvents = [],
        kendoClose = function (e) {

            close.apply(this, [e]);

            if (!e.isDefaultPrevented()) {
                delete screens[screenName];
                for (let ii = 0; ii < dialogEvents.length; ii++) {
                    let handler = dialogEvents[ii].handler;
                    var domId = dialogEvents[ii].domId;

                    if (handler) {
                        $("body").off("click", (`#${domId}`), handler);
                        $("body").off("click", (`#${domId}`), closeKendoWindow);
                    } else {
                        $("body").off("click", (`#${domId}`));
                    }
                }
                var windows = $(".k-window");
                if (windows.length <= 1) {
                    $(".k-overlay").remove();
                } else {
                    var lastWindow = $(windows[windows.length - 2]);
                    var zIndex = lastWindow.css("z-index") as any;
                    $(".k-overlay").css("z-index", zIndex - 1);
                }
            }

            $(e.sender.element[0]).parents(".k-window").remove();
        };

    options.scrollable = options.scrollable || false;
    options.close = kendoClose;
    options.center = options.center == false ? false : true;
    options.overlay = options.overlay == false ? false : true;
    options.width = options.width || ($(document).width() + 200 < 1366
        ? $(document).width() - 200
        : 1366);
    options.actions = options.actions || ["Close"];
    options.resizable = options.resizable || false;
    options.keepContentBox = options.keepContentBox || false;
    options.classes = options.classes || "";
    options.footerComponents = options.footerComponents || [];

    var buttonContainer = $("<div class='popup-button-container col-xs-12'></div>");

    for (let ii = buttons.length - 1; ii >= 0; ii--) {
        var button = buttons[ii];
        var btnId = `${this.id}_${(button.id || getAvailableId())}`;

        let handler = button.clickEvent
            ? button.clickEvent
            : emptyFn;
        var buttonClass = button.className
            ? button.className
            : "";

        btnId = btnId.replace(/ /g, "_");
        btnId = btnId.replace(/[^\w\s]/gi, "");

        var btnHtml = [
            `<div class="action-button-container ${buttonClass} ${button.name == (options.cancelText || ll("Cancel")) ? "left" : ""}"><button id="`, btnId, '" class="action-button', '">',
            button.name,
            "</button></div>"
        ].join("");

        buttonContainer.append($(btnHtml));

        var closeKendoWindow = function (e) {
            if (!e.isDefaultPrevented()) {
                $(`#${id}`).data("kendoWindow") && $("#" + id).data("kendoWindow").close();
            }
        };

        $("body").tie("click", (`#${btnId}`), handler);
        $("body").tie("click", (`#${btnId}`), closeKendoWindow);

        dialogEvents.push({ domId: btnId, handler: handler });
        dialogEvents.push({ domId: btnId, handler: closeKendoWindow });
    }

    for (var componentIndex = 0; componentIndex < options.footerComponents.length; componentIndex++) {
        var component = options.footerComponents[componentIndex];
        component.label = component.label || "";

        if (component.type == "Checkbox") {
            var checkBoxHtml = "<div class=\"checkbox right pad-t-16 mar-r-0\">";
            checkBoxHtml += "<label class=\"checkbox-wrapper\">";

            if (component.id) {
                checkBoxHtml += "<input type=\"checkbox\" id=\"" + component.id + "\" class=\"checkbox-input\">";
            } else {
                checkBoxHtml += "<input type=\"checkbox\" class=\"checkbox-input\">";
            }

            checkBoxHtml += "<span class=\"checkbox-container\">";
            checkBoxHtml += "<span class=\"checkbox-check\"></span>";
            checkBoxHtml += "</span>";
            checkBoxHtml += "<span class=\"checkbox-label popup-footer-checkbox-label\">" + component.label + "</span>";
            checkBoxHtml += "</label>";
            checkBoxHtml += "</div>";

            buttonContainer.append($(checkBoxHtml));
        }
    }

    options.subHeader = "<div class='sub-header'>" + (options.subHeader || "") + "</div>";

    options.guts = "<div class='js-popup-scroll contents'>" + (options.guts || "") + "</div>";

    if ($(`#${id}`).length == 0) {
        let windowContainer = "<div id='" + id + "' class='" + options.classes + "'>" +
            options.subHeader +
            options.guts +
            (options.removeButtons ? "" : $("<div></div>").append(buttonContainer).html()) +
            "</div>";

        let siteContainer = $("#SiteContainer");
        if (siteContainer.length == 0) {
            siteContainer = $(".site-container");
        }

        if (siteContainer.length == 0) {
            siteContainer = $("#app");
        }
        siteContainer.prepend(windowContainer);
    } else {
        $(`#${id}`).html(options.guts);
        $(`#${id}`).parents(".k-widget.k-window").show();
        $(`#${id}`).attr("class", "k-window-content k-content " + options.classes);
    }

    var kWindow = $(`#${id}`);

    var deactivate = options.deactivate;
    options.deactivate = function () {
        deactivate && deactivate();
        kWindow.parents(".k-window").remove();
    };

    options.draggable = true;
    options.position = { top: $(window).scrollTop() };

    options.visible = false;
    options.animation = { open: {effects: "expand:vertical fadeIn"}, close: { effects: "expand:vertical fadeIn", reverse: true } };

    kWindow.kendoWindow(options);
    var kWindowData = kWindow.data("kendoWindow");

    if (kWindowData) {
        this.container = $(`#${this.screenId}`);
        this.guts = this.container.find(".contents");
        this.subHeader = this.container.find(".sub-header");

        if (options.print) {
            var printHTML = (options.print ? "<span class='print'></span>" : "");
            kWindow.parent().find(".k-window-titlebar.k-header").append(printHTML);
        }
        if (options.titleClasses) {
            kWindow.parent().find(".k-window-titlebar.k-header").find(".k-window-title").addClass(options.titleClasses);
        }
        if (options.actionsClasses) {
            kWindow.parent().find(".k-window-actions").addClass(options.actionsClasses);
        }
        if (options.contentClasses) {
            kWindow.parent().find(".k-window-content.k-content").addClass(options.contentClasses);
        }
        if (options.windowClasses) {
            kWindow.parent().addClass(options.windowClasses);
        }

        if (options.center) {
            const centerWindow = () => {
                kWindowData.center();
            };
            setTimeout(centerWindow, 1000);
        }

        if (options.actions.length == 0) {
            kWindow.parents(".k-widget.k-window").find(".k-window-actions").remove();
        }

        kWindowData && kWindowData.bind("dragstart", function () {
            fixKendoWindowDrag(kWindowData.element);
        });

        if (options.overlay) {
            var overlay = $(".k-overlay");
            if (overlay.length == 0) {
                $("<div class='k-overlay'></div>").appendTo($("body"));
                overlay = $(".k-overlay");
            }

            overlay.show();
            overlay.css("z-index", overlayZIndex);
        }

        this.window = kWindowData;

        if (options.gutsClasses) {
            this.guts.addClass(options.gutsClasses);
        }

        if (!options.keepContentBox) {
            this.guts.removeClass("contents");
        }

        this.window.wrapper.css("z-index", popupZIndex);

        const showWindow = () => {
            kWindowData.open();
        };
        setTimeout(showWindow, 1000);
    }
};

PopUp.prototype = {
    setGuts: function (guts) {
        var me = this;
        me.guts.html(guts);
    },
    setSubHeader: function (guts) {
        var me = this;
        me.subHeader.html(guts);
    }
};

/*
    * popUp
    * Opens a dialog pop up with these arguements
    *
    * All Kendo UI Window options are accepted
    *
    * Additional options
    * Id - ID of the window created
    * close - function you want to execute on close
    * buttons - array of button objects (name, clickEvent, className)
    * subHeader - extra information available under header
    * guts - HTML you want inside the window
    * center - boolean to center the window
    * overlay - boolean to show or hide the overlay behind
    *
    * Defaults:
    * id = "dialog"
    * buttons = [{ name: "OK" }]
    * width = "600px"
    * actions = ["Close"]
    * center = true
    * overlay = true
    *
    */
export function popUp(options) {
    return new PopUp(options);
}
